import { put, takeLeading } from 'redux-saga/effects';

import settingApi from 'api/settingApi';
import { apiErrorHandler } from 'utils';

import {
  // GET ROOM IMAGES
  GET_SETTING,
  GET_SETTING_SUCCESS,
  GET_SETTING_FAILED,
} from './actionTypes';

function* getSetting({ payload }) {
  try {
    const response = yield settingApi.getSetting(payload);

    yield put({
      type: GET_SETTING_SUCCESS,
      payload: response.payload,
    });

    payload?.callback(response.payload);
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_SETTING_FAILED,
    });
  }
}

export default function* settingSaga() {
  yield takeLeading(GET_SETTING, getSetting);
}
